import { ApplicationTypes, Model, attachComponent } from 'awr-domain'

import { memoEval, propertyPageComponent } from '@salsita-ai/platform-project-sdk/domain'
import { AttributeListSelector, AttributeToggleSelector } from '@salsita-ai/platform-project-sdk/react'
import { PropertyContainer } from '@salsita-ai/platform-project-sdk/ui'

export const handrailEndComponents = [
  attachComponent
    .withEntity('HandrailEnd')
    .withComponent(propertyPageComponent, 'main')
    .withGradualFilter({
      navigationStates: [ApplicationTypes.NavigationState.Properties],
    })
    .attach(
      memoEval(
        s => [s.id, s.possibleWallEndType, s.$deckItem.$deck.handrailType],
        (id, possibleWallEndType, handrailType) => {
          if (handrailType === Model.HandrailType.FlatTimber) {
            return {
              page: <></>,
            }
          }

          return {
            page: (
              <>
                <PropertyContainer.Group spacing="large">
                  <PropertyContainer.Item title="End Type" description="Choose your handrail end cap or wall fixing">
                    <AttributeToggleSelector entityId={id} instanceName="possibleWallEndType" />
                  </PropertyContainer.Item>
                  {possibleWallEndType === Model.HandrailPossibleWallEndType.Wall && (
                    <PropertyContainer.Item
                      title="Wall fixing Type"
                      description="Choose your handrail wall fixing type"
                    >
                      <AttributeListSelector entityId={id} instanceName="wallEndType" />
                    </PropertyContainer.Item>
                  )}
                  {possibleWallEndType === Model.HandrailPossibleWallEndType.Free &&
                    handrailType === Model.HandrailType.RoundStainless && (
                      <PropertyContainer.Item title="End Cap Type" description="Choose your handrail end cap type">
                        <AttributeListSelector entityId={id} instanceName="freeEndType" />
                      </PropertyContainer.Item>
                    )}
                </PropertyContainer.Group>
              </>
            ),
          }
        }
      )
    ),
]
